export function promoDiscount(promos, p, qty) {
  let best = 0;
  let name = "";
  for (const pr of promos) {
    if (pr.scope === "product" && !pr.target_ids.includes(p.id)) continue;
    if (pr.scope === "category" && !pr.target_ids.includes(p.category_id)) continue;
    if (qty < (pr.min_qty || 1)) continue;
    const gross = p.price * qty;
    const d = Math.round(pr.type === "percent" ? (gross * pr.value) / 100 : Math.min(pr.value * qty, gross));
    if (d > best) {
      best = d;
      name = pr.name;
    }
  }
  return { discount: best, name };
}

export const tierOf = (spent) => (spent >= 5000000 ? ["Gold", "#F5A524"] : spent >= 1000000 ? ["Silver", "#94A3B8"] : ["Bronze", "#B45309"]);

const urlB64 = (b) => {
  const s = atob((b + "=".repeat((4 - (b.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...s].map((c) => c.charCodeAt(0)));
};

export async function enablePush(api) {
  if (!("serviceWorker" in navigator) || !("PushManager" in window))
    throw new Error("Browser ini belum mendukung notifikasi push. Di iPhone, instal aplikasi ke Layar Utama dulu (iOS 16.4+).");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Izin notifikasi ditolak. Aktifkan di pengaturan browser.");
  const reg = await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/public-key");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlB64(data.key) });
  await api.post("/push/subscribe", sub.toJSON());
}

export async function pushStatus() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return "unsupported";
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg && (await reg.pushManager.getSubscription());
  return sub && Notification.permission === "granted" ? "on" : "off";
}
